<template>
  <router-view name="failedOrder" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "FailedOrder",
};
</script>